
// Those imports are for webpack.
import './lib/materialize.min.js';
// import '../css/core.css';
import '../index.html';
import '../config.json';
import '../manifest.json';
import './base.js';
